module.exports = __webpack_public_path__ + "static/card-business-opportunities-2-9eea02edc0be7cc95055f977f5f2e6bb.jpg";